<script setup>
import { ref } from 'vue'

// Vars
const selectedCategory = ref('')

defineProps({
    items: {
        type: Array,
        default: null,
    },
})
</script>

<template>
    <div>
        <v-select v-model="selectedCategory" v-bind="$attrs" :items="items" clearable> </v-select>
    </div>
</template>

<style scoped></style>
